// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1DYrY","ranges":"BmiRanges_ranges__1W1H4"};